import React from 'react';
import { observer } from 'mobx-react';

import { UiIcon, UiNavLink } from 'shared/uikit-new';
import { ROUTES } from 'shared/constants';
import { ChatMessagesModule } from 'shared/modules';

import './styles.scss';

export const LayoutMenuMobileChatMessages = observer(() => {
    return (
        <UiNavLink to={ROUTES.CHATS()} className='layout-menu-mobile-item'>
            <UiIcon.MessageCircle size={24} />
            {!!ChatMessagesModule.unreadCount && <div className='layout-menu-mobile-item__counter'>{ChatMessagesModule.unreadCount}</div>}
        </UiNavLink>
    );
});
